// src/components/ProtectedRoute.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      navigate('/login');
      return;
    }

    // Verify token with backend
    const verifyToken = async () => {
      try {
        console.log('Verifying token...');
        
        const response = await fetch('https://propertyearn.net/api/api/verify-token', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();
        
        if (response.ok) {
          // ✅ FIXED: Handle consistent response format
          // Backend returns {valid: true, user: {...}} from verify-token
          if (data.valid === true && data.user) {
            console.log('Token verification successful');
            setAuthenticated(true);
            
            // ✅ Token is valid, allow access to protected route
            // User data will be fetched by individual components as needed
          } else {
            throw new Error('Invalid token response format');
          }
        } else {
          throw new Error(data.error || 'Token verification failed');
        }
      } catch (err) {
        console.error('Token verification error:', err.message);
        
        // Clear invalid token
        localStorage.removeItem('token');
        
        // Navigate to login with error message
        navigate('/login', { 
          state: { error: 'Session expired. Please login again.' } 
        });
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, [navigate]);

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress />
      </Box>
    );
  }

  return authenticated ? children : null;
}